/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets UAOnlineCategoryList from api:
 * /v1/ua/sd_online_categories
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdOnlineCategoriesUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_online_categories`,
    models.UAOnlineCategoryList
  );
};

export { fetchSdOnlineCategoriesUtil };
